import React, { useEffect, useState } from "react";
import { HOTMART_URL } from "../../lib/constants";
import { X, Gift, ArrowRight, ShieldCheck } from "lucide-react";

const STORAGE_KEY = "kg_exit_popup_shown_v2";

export default function ExitIntentPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    let scrollTimeout;
    let lastScroll = window.scrollY;
    let idleTimer;

    const show = () => {
      if (sessionStorage.getItem(STORAGE_KEY)) return;
      sessionStorage.setItem(STORAGE_KEY, "1");
      setOpen(true);
    };

    const onMouseLeave = (e) => {
      if (e.clientY <= 0) show();
    };
    const onScroll = () => {
      const current = window.scrollY;
      const delta = lastScroll - current;
      if (current > 600 && delta > 80) {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(show, 150);
      }
      lastScroll = current;
    };

    idleTimer = setTimeout(show, 45000);
    document.addEventListener("mouseleave", onMouseLeave);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      document.removeEventListener("mouseleave", onMouseLeave);
      window.removeEventListener("scroll", onScroll);
      clearTimeout(idleTimer);
      clearTimeout(scrollTimeout);
    };
  }, []);

  if (!open) return null;
  const close = () => setOpen(false);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="exit-popup-title"
      data-testid="exit-intent-popup"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 bg-black/80 backdrop-blur-sm animate-[fadeIn_0.2s_ease-out]"
      onClick={close}
    >
      <style>{`
        @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(24px) scale(0.98); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>

      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-lg bg-[#0A0A0A] border border-yellow-400/40 shadow-[0_40px_120px_-20px_rgba(253,224,71,0.35)] animate-[slideUp_0.35s_cubic-bezier(0.22,1,0.36,1)]"
      >
        <div aria-hidden="true" className="h-2 warning-stripes" />

        <button
          onClick={close}
          data-testid="exit-popup-close"
          aria-label="Fechar"
          className="absolute top-5 right-5 w-8 h-8 flex items-center justify-center text-zinc-500 hover:text-white hover:bg-white/10 transition-colors z-10"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="p-6 sm:p-10">
          <div className="inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/40 text-yellow-400 px-3 py-1.5 text-[11px] uppercase tracking-[0.25em] font-bold">
            <Gift className="w-3.5 h-3.5" />
            Antes de saíres — Bónus grátis
          </div>

          <h2
            id="exit-popup-title"
            className="mt-5 font-display text-3xl sm:text-4xl leading-[0.95] text-white uppercase"
          >
            RECEBE AGORA O <br />
            <span className="text-yellow-400">GUIA PDF</span> DAS 10
            <br />
            PERGUNTAS DO SIGO.
          </h2>

          <p className="mt-5 text-zinc-300 leading-relaxed">
            Entra agora para o Pacote Completo e recebes <span className="text-white font-semibold">imediatamente
            no teu email</span> o guia PDF com as 10 perguntas mais frequentes no exame
            teórico SIGO — respondidas e explicadas pelo Kawan.
          </p>

          <ul className="mt-5 space-y-2 text-sm text-zinc-300">
            <li className="flex items-start gap-2">
              <span className="text-yellow-400 mt-0.5">✓</span>
              <span>10 perguntas reais que já caíram no exame</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-yellow-400 mt-0.5">✓</span>
              <span>Respostas explicadas passo-a-passo</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-yellow-400 mt-0.5">✓</span>
              <span>Entregue no email em segundos após a compra</span>
            </li>
          </ul>

          <div className="mt-6 flex items-end justify-between border-t border-white/10 pt-5">
            <div>
              <div className="text-[11px] uppercase tracking-widest text-zinc-500">Valor do guia</div>
              <div className="flex items-baseline gap-3 mt-1">
                <span className="text-zinc-500 line-through font-display text-lg">29€</span>
                <span className="font-display text-3xl text-yellow-400">GRÁTIS</span>
              </div>
            </div>
            <span className="text-[10px] uppercase tracking-widest text-zinc-500">
              com Pacote Completo
            </span>
          </div>

          <a
            href={HOTMART_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
            data-testid="exit-popup-cta"
            className="mt-6 group w-full inline-flex items-center justify-center gap-3 bg-yellow-400 hover:bg-yellow-300 text-black font-display tracking-wide text-base sm:text-lg px-6 py-5 transition-colors"
          >
            QUERO O PACOTE + BÓNUS
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </a>

          <button
            onClick={close}
            data-testid="exit-popup-decline"
            className="mt-3 w-full text-center text-xs uppercase tracking-widest text-zinc-600 hover:text-zinc-400 transition-colors py-2"
          >
            Não obrigado
          </button>

          <div className="mt-5 flex justify-center text-[10px] uppercase tracking-widest text-zinc-500">
            <span className="flex items-center gap-1.5">
              <ShieldCheck className="w-3 h-3 text-yellow-400" /> Garantia 14 dias
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
